"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECONDS_MULTIPLIER = exports.DEFAULT_GATEWAY_ID = exports.DEFAULT_INIT_TIMEOUT = exports.INIT_TIMEOUT_MESSAGE = exports.EMBED_PARAMETER_NAME = exports.HQO_SDK_EVENTS_SET = exports.HQO_SDK_EVENT_SUFFIX = exports.POST_MESSAGE_TARGET_ORIGIN = exports.WINDOW_POST_MESSAGE_EVENT_NAME = exports.HQO_SDK_EVENT_NAME = void 0;
var sdk_message_types_1 = require("./types/sdk-message.types");
exports.HQO_SDK_EVENT_NAME = 'hqoSdkEvents';
exports.WINDOW_POST_MESSAGE_EVENT_NAME = 'message';
exports.POST_MESSAGE_TARGET_ORIGIN = '*';
exports.HQO_SDK_EVENT_SUFFIX = 'Response';
exports.HQO_SDK_EVENTS_SET = new Set(Object.values(sdk_message_types_1.HQO_SDK_ACTIONS).map(function (sdkAction) { return "".concat(sdkAction).concat(exports.HQO_SDK_EVENT_SUFFIX); }));
exports.EMBED_PARAMETER_NAME = 'embed';
exports.INIT_TIMEOUT_MESSAGE = 'sdk init timeout';
exports.DEFAULT_INIT_TIMEOUT = 7000;
exports.DEFAULT_GATEWAY_ID = 6;
exports.SECONDS_MULTIPLIER = 1000;
//# sourceMappingURL=sdk.constants.js.map